export const PERMISSIONS = {
  APPLICATION: {
    CONTRACT_ACCESS: "pms.contract.access",
    EQUIPMENT_ACCESS: "pms.equipment.access",
    SUBCONTRACT_ACCESS: "pms.subcontract.access",
    SYSTEM_ACCESS: "pms.system.access",
  },

  CONTRACT: {
    DASHBOARD_READ: "contract.dashboard.read",

    CALENDAR_CREATE: "contract.calendar.create",
    CALENDAR_DELETE: "contract.calendar.delete",
    CALENDAR_READ: "contract.calendar.read",
    CALENDAR_UPDATE: "contract.calendar.update",

    CONTRACT_CREATE: "contract.contract.create",
    CONTRACT_DELETE: "contract.contract.delete",
    CONTRACT_READ: "contract.contract.read",
    CONTRACT_UPDATE: "contract.contract.update",

    CONTRACT_HISTORY_READ: "contract.contract_history.read",

    CONTRACT_ITEM_CREATE: "contract.contract_item.create",
    CONTRACT_ITEM_DELETE: "contract.contract_item.delete",
    CONTRACT_ITEM_EXPORT: "contract.contract_item.export",
    CONTRACT_ITEM_IMPORT: "contract.contract_item.import",
    CONTRACT_ITEM_READ: "contract.contract_item.read",
    CONTRACT_ITEM_UPDATE: "contract.contract_item.update",

    CONTRACT_PAYMENT_CREATE: "contract.contract_payment.create",
    CONTRACT_PAYMENT_DELETE: "contract.contract_payment.delete",
    CONTRACT_PAYMENT_READ: "contract.contract_payment.read",
    CONTRACT_PAYMENT_UPDATE: "contract.contract_payment.update",

    NOTIFICATION_DELETE: "contract.notification.delete",
    NOTIFICATION_READ: "contract.notification.read",
    NOTIFICATION_UPDATE: "contract.notification.update",
  },

  SUBCONTRACT: {
    ACCEPTANCE_APPROVAL_APPROVE: "subcontract.acceptance_approval.approve",
    ACCEPTANCE_APPROVAL_READ: "subcontract.acceptance_approval.read",
    ACCEPTANCE_APPROVAL_SUBMIT: "subcontract.acceptance_approval.submit",

    DASHBOARD_READ: "subcontract.dashboard.read",

    DRAFT_ACCEPTANCE_ITEM_UPDATE: "subcontract.draft_acceptance_item.update",
    DRAFT_ITEM_UPDATE: "subcontract.draft_item.update",

    STATISTICS_READ: "subcontract.statistics.read",

    SUBCONTRACT_CREATE: "subcontract.subcontract.create",
    SUBCONTRACT_DELETE: "subcontract.subcontract.delete",
    SUBCONTRACT_EXPORT: "subcontract.subcontract.export",
    SUBCONTRACT_READ: "subcontract.subcontract.read",
    SUBCONTRACT_UPDATE: "subcontract.subcontract.update",

    SUBCONTRACT_ACCEPTANCE_CREATE: "subcontract.subcontract_acceptance.create",
    SUBCONTRACT_ACCEPTANCE_DELETE: "subcontract.subcontract_acceptance.delete",
    SUBCONTRACT_ACCEPTANCE_EXPORT: "subcontract.subcontract_acceptance.export",
    SUBCONTRACT_ACCEPTANCE_IMPORT: "subcontract.subcontract_acceptance.import",
    SUBCONTRACT_ACCEPTANCE_READ: "subcontract.subcontract_acceptance.read",
    SUBCONTRACT_ACCEPTANCE_UPDATE: "subcontract.subcontract_acceptance.update",

    SUBCONTRACT_APPROVAL_APPROVE: "subcontract.subcontract_approval.approve",
    SUBCONTRACT_APPROVAL_READ: "subcontract.subcontract_approval.read",
    SUBCONTRACT_APPROVAL_SUBMIT: "subcontract.subcontract_approval.submit",

    SUBCONTRACT_HISTORY_READ: "subcontract.subcontract_history.read",

    SUBCONTRACT_ITEM_EXPORT: "subcontract.subcontract_item.export",
    SUBCONTRACT_ITEM_IMPORT: "subcontract.subcontract_item.import",
    SUBCONTRACT_ITEM_READ: "subcontract.subcontract_item.read",

    SUBCONTRACT_PAYMENT_CREATE: "subcontract.subcontract_payment.create",
    SUBCONTRACT_PAYMENT_DELETE: "subcontract.subcontract_payment.delete",
    SUBCONTRACT_PAYMENT_READ: "subcontract.subcontract_payment.read",
    SUBCONTRACT_PAYMENT_UPDATE: "subcontract.subcontract_payment.update",

    NOTIFICATION_DELETE: "subcontract.notification.delete",
    NOTIFICATION_READ: "subcontract.notification.read",
    NOTIFICATION_UPDATE: "subcontract.notification.update",
  },

  SYSTEM: {
    PROVINCE_READ: "system.province.read",
    PROVINCE_CREATE: "system.province.create",
    PROVINCE_UPDATE: "system.province.update",
    PROVINCE_DELETE: "system.province.delete",
    COMMUNE_READ: "system.commune.read",
    COMMUNE_CREATE: "system.commune.create",
    COMMUNE_UPDATE: "system.commune.update",
    COMMUNE_DELETE: "system.commune.delete",
    ENTERPRISE_READ: "system.enterprise.read",
    ENTERPRISE_CREATE: "system.enterprise.create",
    ENTERPRISE_UPDATE: "system.enterprise.update",
    ENTERPRISE_DELETE: "system.enterprise.delete",
    CLIENT_CREATE: "system.client.create",
    CLIENT_DELETE: "system.client.delete",
    CLIENT_READ: "system.client.read",
    CLIENT_UPDATE: "system.client.update",

    CONTRACT_GROUP_CREATE: "system.contract_group.create",
    CONTRACT_GROUP_DELETE: "system.contract_group.delete",
    CONTRACT_GROUP_READ: "system.contract_group.read",
    CONTRACT_GROUP_UPDATE: "system.contract_group.update",

    CONTRACTOR_CREATE: "system.contractor.create",
    CONTRACTOR_DELETE: "system.contractor.delete",
    CONTRACTOR_READ: "system.contractor.read",
    CONTRACTOR_UPDATE: "system.contractor.update",

    DEPARTMENT_CREATE: "system.department.create",
    DEPARTMENT_DELETE: "system.department.delete",
    DEPARTMENT_READ: "system.department.read",
    DEPARTMENT_UPDATE: "system.department.update",

    DEPARTMENT_UNIT_CREATE: "system.department_unit.create",
    DEPARTMENT_UNIT_DELETE: "system.department_unit.delete",
    DEPARTMENT_UNIT_READ: "system.department_unit.read",
    DEPARTMENT_UNIT_UPDATE: "system.department_unit.update",

    DOCUMENT_TYPE_CREATE: "system.document_type.create",
    DOCUMENT_TYPE_DELETE: "system.document_type.delete",
    DOCUMENT_TYPE_READ: "system.document_type.read",
    DOCUMENT_TYPE_UPDATE: "system.document_type.update",

    LOG_READ: "system.log.read",

    PERMISSION_APPLICATION_ASSIGN: "system.permission_application.assign",
    PERMISSION_APPLICATION_READ: "system.permission_application.read",
    PERMISSION_FUNCTION_ASSIGN: "system.permission_function.assign",
    PERMISSION_FUNCTION_READ: "system.permission_function.read",

    PERSONNEL_CREATE: "system.personnel.create",
    PERSONNEL_DELETE: "system.personnel.delete",
    PERSONNEL_READ: "system.personnel.read",
    PERSONNEL_UPDATE: "system.personnel.update",

    RELEASE_LOG_READ: "system.release_log.read",

    SUBCONTRACT_EXECUTION_GROUP_CREATE: "system.subcontract_execution_group.create",
    SUBCONTRACT_EXECUTION_GROUP_DELETE: "system.subcontract_execution_group.delete",
    SUBCONTRACT_EXECUTION_GROUP_READ: "system.subcontract_execution_group.read",
    SUBCONTRACT_EXECUTION_GROUP_UPDATE: "system.subcontract_execution_group.update",

    SUBCONTRACT_EXECUTION_GROUP_USER_CREATE: "system.subcontract_execution_group_user.create",
    SUBCONTRACT_EXECUTION_GROUP_USER_DELETE: "system.subcontract_execution_group_user.delete",
    SUBCONTRACT_EXECUTION_GROUP_USER_READ: "system.subcontract_execution_group_user.read",
    SUBCONTRACT_EXECUTION_GROUP_USER_UPDATE: "system.subcontract_execution_group_user.update",

    USER_CREATE: "system.user.create",
    USER_DELETE: "system.user.delete",
    USER_READ: "system.user.read",
    USER_UPDATE: "system.user.update",

    ROLE_IN_CONTRACT_CREATE: "system.role_in_contract.create",
    ROLE_IN_CONTRACT_DELETE: "system.role_in_contract.delete",
    ROLE_IN_CONTRACT_READ: "system.role_in_contract.read",
    ROLE_IN_CONTRACT_UPDATE: "system.role_in_contract.update",

    UNIT_IN_CONTRACT_CREATE: "system.unit_in_contract.create",
    UNIT_IN_CONTRACT_DELETE: "system.unit_in_contract.delete",
    UNIT_IN_CONTRACT_READ: "system.unit_in_contract.read",
    UNIT_IN_CONTRACT_UPDATE: "system.unit_in_contract.update",

    ROLE_IN_SUBCONTRACT_CREATE: "system.role_in_subcontract.create",
    ROLE_IN_SUBCONTRACT_DELETE: "system.role_in_subcontract.delete",
    ROLE_IN_SUBCONTRACT_READ: "system.role_in_subcontract.read",
    ROLE_IN_SUBCONTRACT_UPDATE: "system.role_in_subcontract.update",

    UNIT_IN_SUBCONTRACT_CREATE: "system.unit_in_subcontract.create",
    UNIT_IN_SUBCONTRACT_DELETE: "system.unit_in_subcontract.delete",
    UNIT_IN_SUBCONTRACT_READ: "system.unit_in_subcontract.read",
    UNIT_IN_SUBCONTRACT_UPDATE: "system.unit_in_subcontract.update",
  },

  EQUIPMENT: {
    BORROW_HISTORY_READ: "equipment.borrow_history.read",
    BORROW_REQUEST_CREATE: "equipment.borrow_request.create",
    CALIBRATION_READ: "equipment.calibration.read",
    EQUIPMENT_READ: "equipment.equipment.read",
    RETURN_HISTORY_READ: "equipment.return_history.read",
    RETURN_REQUEST_CREATE: "equipment.return_request.create",
  },
};

export default PERMISSIONS;
